import type { SchemaHandleOptions } from '../shared'

export const RETIRED_VIDEO_GENERATOR_AUDIO_INPUT_HANDLES: readonly string[] = [
  'in_generate_audio',
  'in_use_voice_profile_audio_references',
  'in_audio_remix_mode',
  'in_tts_provider',
  'in_dub_target_language',
  'in_resolved_voice_map',
  'in_audio_remix_config',
  'in_speech_transformer_config',
  'in_audio_take_selections',
  'in_audio_variant_workspaces',
  'in_unified_audio_config',
]

export const RETIRED_VIDEO_GENERATOR_AUDIO_OUTPUT_HANDLES: readonly string[] = [
  'out_tts_segments',
  'out_audio_remix_baseline',
  'out_speech_transformer_spans',
  'out_auto_dialogue',
  'out_speech_windows',
  'out_native_speech_takes',
  'out_native_speech_spans',
  'out_native_speech_detect_seq',
  'out_dialogue',
]

export const retiredVideoGeneratorAudioInputHandleOverrides = {
  in_generate_audio: { disabled: true },
  in_use_voice_profile_audio_references: { disabled: true },
  in_audio_remix_mode: { disabled: true },
  in_tts_provider: { disabled: true },
  in_dub_target_language: { disabled: true },
  in_resolved_voice_map: { disabled: true },
  in_audio_remix_config: { disabled: true },
  in_speech_transformer_config: { disabled: true },
  in_audio_take_selections: { disabled: true },
  in_audio_variant_workspaces: { disabled: true },
  in_unified_audio_config: { disabled: true },
} satisfies NonNullable<SchemaHandleOptions['inputs']>

export const retiredVideoGeneratorAudioOutputHandleOverrides = {
  out_tts_segments: { disabled: true },
  out_audio_remix_baseline: { disabled: true },
  out_speech_transformer_spans: { disabled: true },
  out_auto_dialogue: { disabled: true },
  out_speech_windows: { disabled: true },
  out_native_speech_takes: { disabled: true },
  out_native_speech_spans: { disabled: true },
  out_native_speech_detect_seq: { disabled: true },
  out_dialogue: { disabled: true },
} satisfies NonNullable<SchemaHandleOptions['outputs']>
